import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import { UploadClientInsurance } from 'components/clients/client-insurance/components/upload-client-insurance';
import styles from './client-insurance-empty-state.module.scss';
import type { IClientInsuranceEmptyStateProps } from './types';

export const ClientInsuranceEmptyState = (props: IClientInsuranceEmptyStateProps) => {
  const { t } = useTranslation('client');
  const { clientId } = props;

  return (
    <Flex className={styles.content} align='center' justify='center' vertical>
      <Flex className={styles.icon} align='center' justify='center'>
        <SafetyOutlined />
      </Flex>
      <Typography.Text className={styles.title} strong>
        {t('insurance_not_uploaded')}
      </Typography.Text>
      <Typography.Paragraph className={styles.description}>{t('insurance_upload_description')}</Typography.Paragraph>
      <UploadClientInsurance clientId={clientId} />
    </Flex>
  );
};
